var MockBotCardCommandType;
(function (MockBotCardCommandType) {
  MockBotCardCommandType["Hero"] = "hero";
  MockBotCardCommandType["Signin"] = "signin";
  MockBotCardCommandType["Thumbnail"] = "thumbnail";
})(MockBotCardCommandType || (MockBotCardCommandType = {}));
export default MockBotCardCommandType;